/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NaturePlantTreeAIcon20Solid = forwardRef('NaturePlantTreeAIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.056 6.212a4.5 4.5 0 0 1 7.726-3.79 4 4 0 0 1 6.19 3.813 5.5 5.5 0 0 1-5.721 9.287v3.228a1.25 1.25 0 1 1-2.501 0v-3.23a5.5 5.5 0 0 1-5.694-9.309ZM9.125 15h1.75v-3.934l3.566-1.783a.875.875 0 0 0-.782-1.566L10.875 9.11V6a.875.875 0 0 0-1.75 0v4.61L6.341 9.216a.875.875 0 0 0-.782 1.566l3.566 1.783V15Z" })));
});
